import { useEffect, useState } from "react";

interface HoneypotFieldProps {
  onBot: () => void;
}

/**
 * Champ invisible pour détecter les bots qui remplissent automatiquement les formulaires
 * Les utilisateurs humains ne le verront pas et ne le rempliront pas
 */
export const HoneypotField = ({ onBot }: HoneypotFieldProps) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    if (value) {
      // Si le champ est rempli, c'est probablement un bot
      onBot();
    }
  }, [value, onBot]);

  return (
    <input
      type="text"
      name="website"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      autoComplete="off"
      tabIndex={-1}
      aria-hidden="true"
      style={{
        position: "absolute",
        left: "-9999px",
        width: "1px",
        height: "1px",
        opacity: 0,
        pointerEvents: "none",
      }}
    />
  );
};
